module.exports = __webpack_public_path__ + "img/EST.73e36946.svg";